import type { PropertyIn, PropertyPath } from '@/scopes/common/domain/types'
import { AccoListerAcco } from '@/scopes/common/domain/acco-lister/types'
import { setIn } from '@/scopes/common/domain/functions/objectDeepOperations'
import { createStore } from 'zustand/vanilla'

export interface DestinationOption { name: string, url: string, isSelected: boolean }
interface MapAccoMarker { id: string, lat: number, lng: number }
export interface DestinationState {
  selectorOptions: {
    country: DestinationOption[]
    region: DestinationOption[]
    subregion: DestinationOption[]
    city: DestinationOption[]
  }
  selectorStatus: {
    isLoading: boolean
    hasError: boolean
  }
  popularAccos: AccoListerAcco[]
  popularAccosStatus: {
    isLoading: boolean
    hasError: boolean
  }
  mapAccoMarkers: MapAccoMarker[]
  mapAccoMarkersStatus: {
    isLoading: boolean
    hasError: boolean
  }
}

const defaultInitialState: DestinationState = {
  selectorOptions: {
    country: [],
    region: [],
    subregion: [],
    city: [],
  },
  selectorStatus: {
    isLoading: true,
    hasError: false,
  },
  popularAccos: [],
  popularAccosStatus: {
    isLoading: true,
    hasError: false,
  },
  mapAccoMarkers: [],
  mapAccoMarkersStatus: {
    isLoading: false,
    hasError: false,
  },
}

export interface DestinationActions {
  initialize: (state: DestinationState) => void
  setIn: (path: PropertyPath<DestinationState>, value: PropertyIn<DestinationState, typeof path>) => void
}

export type DestinationStore = DestinationState & DestinationActions

export const destinationStore = createDestinationStore()

export function createDestinationStore(initialState: DestinationState = defaultInitialState) {
  return createStore<DestinationStore>(set => ({
    ...initialState,
    initialize: (state: DestinationState) => {
      set(() => state)
    },
    setIn: (path, value) => {
      set(state => setIn(state, path, value))
    },
  }))
}
